import { db } from '../../firebase';

export const startSendBid = (payload) => {
  return (dispatch) => db.sendBid(payload)
};



// WEBPACK FOOTER //
// ./src/store/actions/messages.js